<template>
    <modal :show="show" @close="close">
        <div class="card-title flex justify-between">
            <div>Создать клиента</div>
        </div>

        <form class="spaced-y-4" @submit.prevent="submit">
            <div class="flex -mx-2">
                <text-field
                    class="w-1/2 px-2"
                    title="Имя"
                    v-model="entry.first_name"
                    :errors="errors.first_name"
                    required
                />

                <text-field
                    class="w-1/2 px-2"
                    title="Фамилия"
                    v-model="entry.last_name"
                    :errors="errors.last_name"
                    required
                />
            </div>

            <div class="flex -mx-2">
                <text-field
                    class="w-1/2 px-2"
                    title="Номер телефона"
                    v-model="entry.phone"
                    :errors="errors.phone"
                    :required="! entry.email"
                />

                <text-field
                    type="email"
                    class="w-1/2 px-2"
                    title="Email"
                    v-model="entry.email"
                    :errors="errors.email"
                    :required="! entry.phone"
                />
            </div>

            <hr class="mb-3" />

            <button class="btn btn-primary">Сохранить</button>
        </form>
    </modal>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import qs from "qs";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "admin.customers",
                endpoint: "admin/customers",
                mode: "create"
            }
        };
    },

    props: {
        show: Boolean
    },

    methods: {
        onStore() {
            this.$emit("create", this.entry);
        },

        close() {
            this.$emit("close");
        }
    },

    mounted() {
        //
    }
};
</script>